export const SET_GOOGLE_ANALYTIC_TRACKING = 'SET_GOOGLE_ANALYTIC_TRACKING';
